import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const s = (p) => /* @__PURE__ */ r(t, { ...p, children: [
  /* @__PURE__ */ o("path", { d: "M17.001 6.81818H6.81915V17H17.001V6.81818Z" }),
  /* @__PURE__ */ o("path", { d: "M13.9101 5.72727V3H3.00098v10.9091h2.72727V5.72727h8.18185Z" })
] });
export {
  s as Copy
};
//# sourceMappingURL=Copy.js.map
